import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton} from '@mui/material';
import Modal from '@mui/material/Modal';
import React from 'react';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { sxButtons, sxCloseIconButton, sxModal } from './sxProps';
import DefaultButton from '../../../../../components/Accessibility/DefaultButton';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../../../../../components/Accessibility/PageTitle';
import DefaultText from '../../../../../components/Accessibility/DefaultText';
import { faCircleCheck } from '@fortawesome/pro-duotone-svg-icons';


interface Props {
  showModal: boolean;
}

const ConfirmacaoModal: React.FC<Props> = ({
  showModal
}) => {

  const navigate = useNavigate();

  const accessibility = useAccessibility();

  const voltar = () => {
    navigate('/saudeBemEstar/unimedAcolhe')
  }

  return (
    <Modal
      open={showModal}
    >
      <Box sx={sxModal} style={{ ...accessibility.textStyleAccessibility, ...accessibility.contrastBorderAccessibility }}>
        <IconButton
          aria-label="fechar"
          onClick={() => voltar()}
          sx={sxCloseIconButton}
        >
          <FontAwesomeIcon icon={faTimes} size="1x" color='black' style={accessibility.textStyleAccessibility} />
        </IconButton>
        <FontAwesomeIcon icon={faCircleCheck} color='#00995D' size='3x' />
        <PageTitle marginBottom="15px" shouldFocus={false} text="Agendamento realizado com sucesso!" />
        <DefaultText alignCenter text="No dia e horário agendados, clique em “Ingressar no atendimento” para acessar a videochamada e realizar o seu atendimento." />
        <Box sx={sxButtons}>
          <DefaultButton text="Manual de atendimento" variant="outlined" onClick={() => navigate('/saudeBemEstar/unimedAcolhe/manualDeAtendimento')} />
          <DefaultButton text="Voltar para o início" onClick={() => voltar()} />
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmacaoModal;
